
if (!customElements.get('back-in-stock')) {

  
class BackInStock extends HTMLElement {
  constructor() {
    super();
    this.klaviyoId = this.dataset.klaviyoId;
    this.productId = this.dataset.productId;
    this.productTitle = this.dataset.productTitle;
    this.variantId = null;

    this.modal = this.querySelector('[data-back-in-stock-modal]');
    this.form = this.querySelector('[data-back-in-stock-form]');
    this.emailInput = this.querySelector('[data-back-in-stock-email]');
    this.submitButton = this.querySelector('button[type="submit"]');
    this.message = this.querySelector('[data-back-in-stock-message]');
    this.variantTitleEl = this.querySelector('[data-back-in-stock-variant-title]');
    this.trigger = document.querySelector('[data-back-in-stock-trigger]')

    this.querySelectorAll('[data-back-in-stock-close]').forEach((el) =>
      el.addEventListener('click', this.closeModal.bind(this))
    );
    if (this.submitButton) {
      this.submitButton.addEventListener('click', this.handleFormSubmit.bind(this)); // Keep this for the modal's own button
    }

    if (this.emailInput) {
      this.emailInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') this.handleFormSubmit(event);
      });
    }

    document.addEventListener('theme:variant:change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    const { variant } = event.detail;
    this.variantId = variant.id;
    if (this.variantTitleEl) {
      this.variantTitleEl.textContent = variant.title;
    }
  }

  openModal() {
    this.modal.showModal();
  }

  closeModal() {
    this.modal.close();
    this.message.innerHTML = '';
    if (this.emailInput) this.emailInput.value = '';
    document.body.classList.remove('modal--open');
  }

  async handleFormSubmit(event) {
    event.preventDefault();
    if (!this.klaviyoId) {
      console.error('Klaviyo Public API Key is not set.');
      this.message.textContent = 'Configuration error.';
      return;
    }

    console.log(this.variantId);
    if (!this.variantId) {
      this.message.textContent = 'Configuration error. No variant';
      return;
    }

    const email = this.emailInput.value;
    if (!email) return;


    this.message.innerHTML = '';

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${this.variantId}`,
            },
          },
        },
      },
    };

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.klaviyoId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-06-15',
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        this.message.innerHTML = `<p class="success">Success! We'll let you know when it's back.</p>`;
        this.emailInput.value = '';
      } else {
        const errorData = await response.json();
        const errorMessage = errorData?.errors?.[0]?.detail || 'An error occurred. Please try again.';
        this.message.innerHTML = `<p class="errors">${errorMessage}</p>`;
      }
    } catch (error) {
      this.message.innerHTML = `<p class="errors">An error occurred. Please try again.</p>`;
    } finally {

    }
  }
}

  customElements.define('back-in-stock', BackInStock);
}

// Global listener to connect external triggers to the modal
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-back-in-stock-trigger]');
  if (trigger) {
    const backInStockEl = document.querySelector('back-in-stock');
    if (backInStockEl) backInStockEl.openModal();
  }
});
